import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import FeatherIcon from "feather-icons-react";

const Navdata = () => {
  const navigate = useNavigate();

  // State برای مدیریت منوی فعال و زیرمنوها
  const [currentMenu, setCurrentMenu] = useState("Dashboard");
  const [isBlogOpen, setIsBlogOpen] = useState(false);

  // تابع برای مدیریت نمایش زیرمنوها
  const updateIconSidebar = (e) => {
    if (e?.target?.getAttribute("subitems")) {
      const ul = document.getElementById("two-column-menu");
      const activeIcons = ul.querySelectorAll(".nav-icon.active");
      activeIcons.forEach((item) => {
        item.classList.remove("active");
        const id = item.getAttribute("subitems");
        if (document.getElementById(id)) {
          document.getElementById(id).classList.remove("show");
        }
      });
    }
  };

  // مدیریت تغییرات منو و ناوبری
  useEffect(() => {
    document.body.classList.remove("twocolumn-panel");
    if (currentMenu === "Widgets") {
      navigate("/widgets");
      document.body.classList.add("twocolumn-panel");
    }
  }, [navigate, currentMenu]);

  const menuItems = [
    {
      label: "منو",
      isHeader: true,
    },
    {
      id: "dashboard",
      label: "داشبورد",
      icon: <FeatherIcon icon="home" className="icon-dual" />,
      link: "/dashboard",
      click: (e) => {
        e.preventDefault();
        setCurrentMenu("Dashboard");
      },
    },
    {
      id: "main",
      label: "مدیریت صفحه اصلی",
      icon: <FeatherIcon icon="layout" className="icon-dual" />,
      link: "/main-page",
      click: (e) => {
        e.preventDefault();
        setCurrentMenu("Main");
      },
    },
    {
      id: "tariff",
      label: "مدیریت تعرفه‌ها",
      icon: <FeatherIcon icon="dollar-sign" className="icon-dual" />,
      link: "/tariff",
      click: (e) => {
        e.preventDefault();
        setCurrentMenu("Tariff");
      },
    },
    {
      id: "about",
      label: "مدیریت درباره ما",
      icon: <FeatherIcon icon="info" className="icon-dual" />,
      link: "/aboutus",
      click: (e) => {
        e.preventDefault();
        setCurrentMenu("About");
      },
    },
    {
      id: "contact",
      label: "مدیریت تماس‌ها",
      icon: <FeatherIcon icon="phone" className="icon-dual" />,
      link: "/contact",
      click: (e) => {
        e.preventDefault();
        setCurrentMenu("Contact");
      },
    },
    {
      id: "faq",
      label: "مدیریت سوالات متداول",
      icon: <FeatherIcon icon="help-circle" className="icon-dual" />,
      link: "/faq",
      click: (e) => {
        e.preventDefault();
        setCurrentMenu("Faq");
      },
    },
    {
      id: "requestCoin",
      label: "مدیریت درخواست سکه",
      icon: <FeatherIcon icon="award" className="icon-dual" />,
      link: "/requestCoin",
      click: (e) => {
        e.preventDefault();
        setCurrentMenu("RequestCoin");
      },
    },
    {
      id: "blog",
      label: "مدیریت وبلاگ",
      icon: <FeatherIcon icon="book" className="icon-dual" />,
      link: "/#",
      stateVariables: isBlogOpen,
      click: (e) => {
        e.preventDefault();
        setIsBlogOpen(!isBlogOpen);
        setCurrentMenu("Blog");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "category",
          label: "مدیریت دسته‌بندی",
          link: "/category",
          parentId: "blog",
        },
        {
          id: "post",
          label: "مدیریت پست",
          link: "/post",
          parentId: "blog",
        },
        {
          id: "comment",
          label: "مدیریت نظرات",
          link: "/comment",
          parentId: "blog",
        },
      ],
    },
  ];

  return <React.Fragment>{menuItems}</React.Fragment>;
};

export default Navdata;